import { render, staticRenderFns } from "./AppointmentHistoricalWrapper.vue?vue&type=template&id=da46c1dc"
import script from "./AppointmentHistoricalWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentHistoricalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports